import useGetApi from '@/api/useGetApi';

export interface Transaction {
  id: string;
  tradingPartner: string | null;
  supplierContractNumber: string | null;
  fileThreeLetterDivision: string;
  claimAmount: number | null;
  rexelSalesOrderNumber: string | null;
  orderDate: string | null;
  invoiceDate: string | null;
  shipmentDate: string | null;
  customerNo: string | null;
  customerName: string | null;
  customerShipToCity: string | null;
  customerShipToStateProvince: string | null;
  customerShipToPostalCode: string | null;
  invoiceNumber: string | null;
  itemInternalCode: string | null;
  description: string | null;
  shippedQuantity: number | null;
  listPrice: number | null;
  buyerCost: number | null;
  coreCostOverride: number | null;
  actualOverrideCost: number | null;
  customerInvoiceAmount: number | null;
  ediSupplierFlag: string | null;
  shipType: string | null;
}

export interface AllTransactionsResponse {
  transactions: Transaction[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
}

export interface AllTransactionsParams {
  tradingPartner?: string;
  shipType?: string;
  division?: string;
  limit?: number;
  offset?: number;
  excludeIds?: string[];
}

export function useRexelAllTransactions({
  tradingPartner,
  shipType,
  division,
  limit = 100,
  offset = 0,
  excludeIds = [],
}: AllTransactionsParams = {}) {
  return useGetApi<AllTransactionsResponse>({
    endpoint: 'rexel/ship-and-debit/844/transactions',
    queryParameters: {
      tradingPartner,
      shipType,
      division: division === 'all' ? undefined : division,
      limit,
      offset,
      excludeIds: excludeIds.length > 0 ? excludeIds.join(',') : undefined,
    },
  });
}
